module.exports = __webpack_public_path__ + "static/media/ils_no_data.7cd60db2.svg";